<template>
  <div>
    <!-- Bottom sheet para observação geral ao finalizar -->
    <v-bottom-sheet v-if="tipo === 'finalize'" v-model="localAberto" >
      <v-card class="">
        <v-card-title
          class="headline"
          :style="{
            backgroundColor: '#4c6faf',
            color: 'white',
          }"
        >
          Observação geral da coleta
        </v-card-title>
        <v-card-text class="mt-2 subtitle-1">
          <p>Deseja adicionar uma observação geral para esta coleta?</p>
          <v-textarea
            v-model="localDados.observacao"
            label="Observação geral (opcional)"
            rows="4"
            auto-grow
            counter
            maxlength="400"
          ></v-textarea>
        </v-card-text>
        <v-card-actions class="justify-space-between">
          <v-btn text color="grey" @click="$_cancelar">Cancelar</v-btn>
          <v-btn color="#61af4c" dark @click="$_confirmarFinalize">
            Salvar e finalizar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-bottom-sheet>

    <!-- Bottom sheet para confirmação de delete de produto -->
<v-bottom-sheet v-if="tipo === 'delete'" v-model="localAberto">
      <v-card class="rounded-t-xl">
        
        <div class="d-flex justify-center pt-3 pb-1">
          <div style="width: 40px; height: 4px; background-color: #e0e0e0; border-radius: 2px;"></div>
        </div>

        <v-card-title class="headline d-flex justify-space-between align-center px-6 pt-2 pb-4">
          <div class="d-flex align-center">
            <v-icon color="error" class="mr-2">mdi-alert-circle-outline</v-icon>
            <span class="font-weight-bold error--text" style="font-size: 1.25rem;">Confirmar Exclusão</span>
          </div>
          <v-btn icon color="grey darken-1" small @click="$_cancelar" aria-label="Fechar">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="px-6 pb-4 subtitle-1 text--primary">
          <p v-if="localDados.produtoNome" class="mb-0">
            Tem certeza que deseja remover o produto <br>
            <strong class="font-weight-black">{{ localDados.produtoNome }}</strong> da coleta?
          </p>
        </v-card-text>

        <v-card-actions class="px-6 pb-6 pt-0 justify-end">
          <v-btn 
            text 
            color="grey darken-1" 
            class="mr-3 text-capitalize font-weight-medium" 
            @click="$_cancelar"
          >
            Cancelar
          </v-btn>
          <v-btn 
            color="error" 
            dark 
            elevation="0" 
            class="px-5 text-capitalize font-weight-medium" 
            @click="$_confirmarDelete"
          >
            <v-icon left size="20">mdi-trash-can-outline</v-icon>
            Remover
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-bottom-sheet>

    <!-- Bottom sheet para editar produto -->
<v-bottom-sheet v-if="tipo === 'edit'" v-model="localAberto">
  <v-card class="rounded-t-xl"> 
    
    <div class="d-flex justify-center pt-3 pb-1">
      <div style="width: 40px; height: 4px; background-color: #e0e0e0; border-radius: 2px;"></div>
    </div>

    <v-card-title class="headline d-flex justify-space-between align-center px-6 pt-2 pb-4">
      <span class="font-weight-bold" style="color: #4c6faf; font-size: 1.25rem;">Editar Item</span>
      <v-btn icon color="grey darken-1" small @click="$_cancelar" aria-label="Fechar">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text class="px-6 pb-2">
      <v-row dense>
        <v-col cols="6" sm="6">
          <v-text-field
            label="Quantidade"
            type="tel"
            outlined
            dense
            maxlength="4"
            v-model="localDados.quantidade"
            @keypress="$_isNumber"
            hide-details="auto"
            color="#4c6faf"
          ></v-text-field>
        </v-col>

        <v-col cols="6" sm="6">
          <v-text-field
            label="Preço"
            outlined
            dense
            v-model="precoFormatado"
            hide-details="auto"
            color="#4c6faf"
          ></v-text-field>
        </v-col>

        <v-col cols="12" class="mt-2">
          <v-textarea
            label="Observação"
            outlined
            dense
            maxlength="300"
            rows="3"
            auto-grow
            counter
            v-model="localDados.observacao"
            prepend-inner-icon="mdi-comment-text-outline"
            hide-details="auto"
            color="#4c6faf"
          ></v-textarea>
        </v-col>
      </v-row>
    </v-card-text>

    <v-card-actions class="px-6 pb-6 pt-0 justify-end">
      <v-btn 
        text 
        color="grey darken-1" 
        class="mr-3 text-capitalize font-weight-medium" 
        @click="$_cancelar"
      >
        Cancelar
      </v-btn>
      <v-btn 
        color="#4c6faf" 
        dark 
        elevation="0" 
        class="px-5 text-capitalize font-weight-medium" 
        @click="$_confirmarEdit"
      >
        <v-icon left size="20">mdi-content-save</v-icon>
        Salvar
      </v-btn>
    </v-card-actions>
  </v-card>
</v-bottom-sheet>

    <!-- Bottom sheet para encerrar a coleta -->
<v-bottom-sheet v-if="tipo === 'encerrar'" v-model="localAberto">
      <v-card class="rounded-t-xl">
        
        <div class="d-flex justify-center pt-3 pb-1">
          <div style="width: 40px; height: 4px; background-color: #e0e0e0; border-radius: 2px;"></div>
        </div>

        <v-card-title class="headline d-flex justify-space-between align-center px-6 pt-2 pb-4">
          <div class="d-flex align-center">
            <v-icon color="#4c6faf" class="mr-2">mdi-check-circle-outline</v-icon>
            <span class="font-weight-bold" style="color: #4c6faf; font-size: 1.25rem;">Encerrar Coleta</span>
          </div>
          <v-btn icon color="grey darken-1" small @click="$_cancelar" aria-label="Fechar">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="px-6 pb-4">
          <p class="subtitle-1 text--primary mb-3">Deseja realmente encerrar esta coleta?</p>
          
          <div v-if="localDados" class="rounded grey lighten-4 pa-4">
            
            <div class="d-flex justify-space-between mb-2">
              <span class="text-body-2 grey--text text--darken-2 font-weight-medium">Cliente:</span>
              <span class="text-body-2 font-weight-bold black--text text-right">{{ localDados.orscliente || '---' }}</span>
            </div>
            
            <div class="d-flex justify-space-between mb-2" v-if="localDados.orsnroexterno">
              <span class="text-body-2 grey--text text--darken-2 font-weight-medium">Nro Externo:</span>
              <span class="text-body-2 font-weight-bold black--text text-right">{{ localDados.orsnroexterno }}</span>
            </div>
            
            <div class="d-flex justify-space-between">
              <span class="text-body-2 grey--text text--darken-2 font-weight-medium">Qtd. Itens:</span>
              <span class="text-body-2 font-weight-bold black--text">{{ localDados.orsquantidade || '0' }}</span>
            </div>

            <template v-if="localDados.orsobservacao">
              <v-divider class="my-3"></v-divider>
              <div>
                <span class="text-caption grey--text text--darken-2 font-weight-bold d-flex align-center mb-1">
                  <v-icon small color="grey darken-2" class="mr-1">mdi-comment-text-outline</v-icon> 
                  OBSERVAÇÃO
                </span>
                <p class="text-body-2 black--text mb-0" style="white-space: pre-line;">{{ localDados.orsobservacao }}</p>
              </div>
            </template>
            
          </div>
        </v-card-text>

        <v-card-actions class="px-6 pb-6 pt-0 justify-end">
          <v-btn 
            text 
            color="grey darken-1" 
            class="mr-3 text-capitalize font-weight-medium" 
            @click="$_cancelar"
          >
            Cancelar
          </v-btn>
          <v-btn 
            color="#4c6faf" 
            dark 
            elevation="0" 
            class="px-5 text-capitalize font-weight-medium" 
            @click="$_confirmarEncerrar"
          >
            <v-icon left size="20">mdi-check</v-icon>
            Encerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-bottom-sheet>

    <!-- Bottom sheet para deletar a coleta -->
<v-bottom-sheet v-if="tipo === 'deletarcoleta'" v-model="localAberto">
      <v-card class="rounded-t-xl">
        
        <div class="d-flex justify-center pt-3 pb-1">
          <div style="width: 40px; height: 4px; background-color: #e0e0e0; border-radius: 2px;"></div>
        </div>

        <v-card-title class="headline d-flex justify-space-between align-center px-6 pt-2 pb-4">
          <div class="d-flex align-center">
            <v-icon color="error" class="mr-2">mdi-alert-circle-outline</v-icon>
            <span class="font-weight-bold error--text" style="font-size: 1.25rem;">Deletar Coleta</span>
          </div>
          <v-btn icon color="grey darken-1" small @click="$_cancelar" aria-label="Fechar">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="px-6 pb-4">
          <p class="subtitle-1 text--primary mb-3">Tem certeza que deseja deletar esta coleta?</p>
          
          <div v-if="localDados" class="rounded grey lighten-4 pa-4 mb-4">
            <div class="d-flex justify-space-between mb-2">
              <span class="text-body-2 grey--text text--darken-2 font-weight-medium">Nº Coleta:</span>
              <span class="text-body-2 font-weight-bold black--text">{{ localDados.id || '---' }}</span>
            </div>
            <div class="d-flex justify-space-between mb-2">
              <span class="text-body-2 grey--text text--darken-2 font-weight-medium">Cliente:</span>
              <span class="text-body-2 font-weight-bold black--text text-right">{{ localDados.orscliente || '---' }}</span>
            </div>
            <div class="d-flex justify-space-between">
              <span class="text-body-2 grey--text text--darken-2 font-weight-medium">Qtd. Itens:</span>
              <span class="text-body-2 font-weight-bold black--text">{{ localDados.orsquantidade || '0' }}</span>
            </div>
          </div>
          
          <div class="d-flex align-start error--text text-body-2 px-1">
            <v-icon small color="error" class="mr-2 mt-1">mdi-alert</v-icon>
            <span><strong>Atenção:</strong> Esta ação não pode ser desfeita. Todos os itens e imagens serão deletados permanentemente.</span>
          </div>
        </v-card-text>

        <v-card-actions class="px-6 pb-6 pt-0 justify-end">
          <v-btn 
            text 
            color="grey darken-1" 
            class="mr-3 text-capitalize font-weight-medium" 
            @click="$_cancelar"
          >
            Cancelar
          </v-btn>
          <v-btn 
            color="error" 
            dark 
            elevation="0" 
            class="px-5 text-capitalize font-weight-medium" 
            @click="$_confirmarDeletarColeta"
          >
            <v-icon left size="20">mdi-trash-can-outline</v-icon>
            Deletar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-bottom-sheet>

    <!-- Bottom sheet para falha de transmissão/conexão -->
    <v-bottom-sheet v-if="tipo === 'erro_conexao'" v-model="localAberto">
      <v-card class="rounded-t-xl">
        <div class="d-flex justify-center pt-3 pb-1">
          <div style="width: 40px; height: 4px; background-color: #e0e0e0; border-radius: 2px;"></div>
        </div>

        <v-card-title class="headline d-flex justify-space-between align-center px-6 pt-2 pb-4">
          <div class="d-flex align-center">
            <v-icon color="error" class="mr-2">mdi-wifi-off</v-icon>
            <span class="font-weight-bold error--text" style="font-size: 1.25rem;">Falha na Transmissão</span>
          </div>
          <v-btn icon color="grey darken-1" small @click="$_cancelar" aria-label="Fechar">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="px-6 pb-4 subtitle-1 text--primary">
          Não foi possível enviar a coleta pois ocorreu um erro na transmissão para o servidor. Ela permanecerá salva localmente e será enviada assim que a conexão com a internet retornar.
        </v-card-text>

        <v-card-actions class="px-6 pb-6 pt-0 justify-end">
          <v-btn color="error" text class="px-5 text-capitalize font-weight-medium" @click="$_cancelar">
            Entendi
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-bottom-sheet>
  </div>
</template>

<script>
import errorHandler from '@/utils/error-handler';
export default {
  name: 'BottomSheetHandler',

  props: {
    aberto: {
      type: Boolean,
      default: false,
    },
    tipo: {
      type: String,
      enum: ['finalize', 'delete', 'edit', 'encerrar', 'deletarcoleta', 'erro_conexao'],
      required: true,
    },
    dados: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      localAberto: this.aberto,
      localDados: JSON.parse(JSON.stringify(this.dados)),
    };
  },

  computed: {
    precoFormatado: {
      get() {
        const valor = parseFloat(this.localDados.preco) || 0;
        return valor.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      },
      set(novoValor) {
        const apenasNumeros = novoValor.toString().replace(/\D/g, '');
        this.$set(this.localDados, 'preco', apenasNumeros ? (parseFloat(apenasNumeros) / 100) : 0);
      }
    }
  },

  watch: {
    aberto(novoValor) {
      this.localAberto = novoValor;
    },
    localAberto(novoValor) {
      if (!novoValor) {
        this.$emit('update:aberto', false);
      }
    },
    dados: {
      handler(novosDados) {
        this.localDados = JSON.parse(JSON.stringify(novosDados));
      },
      deep: true,
    },
  },

  methods: {
    $_isNumber(evt) {
      const keysAllowed = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
      const keyPressed = evt.key;

      if (!keysAllowed.includes(keyPressed)) {
        evt.preventDefault();
      }
    },

    $_confirmarFinalize() {
      this.$emit('confirmar', this.localDados.observacao);
      this.localAberto = false;
    },

    $_confirmarEncerrar() {
      this.$emit('encerrar', this.localDados);
      this.localAberto = false;
    },

    $_confirmarDeletarColeta() {
      this.$emit('deletarcoleta');
      this.localAberto = false;
    },

    $_confirmarDelete() {
      this.$emit('confirmar');
      this.localAberto = false;
    },

    $_confirmarEdit() {
      if (Number(this.localDados.quantidade) <= 0) {
        errorHandler('A quantidade deve ser maior que zero.');
        return;
      }
      this.$emit('confirmar', {
        quantidade: Number(this.localDados.quantidade),
        observacao: this.localDados.observacao,
        preco: Number(this.localDados.preco) || 0,
      });
      this.localAberto = false;
    },

    $_cancelar() {
      this.localAberto = false;
      this.$emit('update:aberto', false);
    },
  },
};
</script>

<style scoped>
.linha {
  display: flex;
  width: 100%;
}

.linha > * {
  padding: 0px 12px 0px 12px;
}

.detalhes-coleta {
  font-size: 1rem;
}

.detalhe-item {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px solid #eee;
}

.detalhe-item--obs {
  padding: 8px 0;
}
</style>
